// Entrypoint for public-facing pages: profile, embed_profile, event, embed_event.
// Boots a small standalone Vue app with only what these pages need, keeping the
// ~4MB dashboard bundle (application.js) off pages that never use it.

import * as Vue from 'vue'
import VCalendar from 'v-calendar'

import MessageForm from 'controllers/vue_components/public/public_message_form'
import Troubleshoot from 'controllers/vue_components/public/troubleshoot'
import SocialIcons from 'controllers/vue_components/events/social_icon'
import PublicEvent from 'components/public_event/index.vue'

window.__VUE_PROD_DEVTOOLS__ = false

const MOUNT_POINT = '#public_booking_app'

// Same hydration `main.js` does before mounting — useConstants() reads window.I18N etc.
function hydrateGlobals() {
  const globalVariablesDiv = document.getElementById('global-variables')
  if (!globalVariablesDiv) return
  const globalVariables = JSON.parse(globalVariablesDiv.getAttribute('data'))
  for (const [key, value] of Object.entries(globalVariables)) {
    window[key] = value
  }
}

function mount() {
  const element = document.querySelector(MOUNT_POINT)
  if (!element || element.innerHTML.trim() === '') return

  hydrateGlobals()

  const app = Vue.createApp({})
  app.use(VCalendar, {})
  app.component('public-message-form', MessageForm)
  app.component('troubleshoot', Troubleshoot)
  app.component('social-icons', SocialIcons)
  app.component('public-event', PublicEvent)
  app.mount(MOUNT_POINT)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount)
} else {
  mount()
}
